import type { StyleRule } from '@archipro-design/aria';
import { captionClassName } from '@archipro-design/aria';

export const LocationCaptionStyle: StyleRule = () => ({
    [`&.${captionClassName}`]: {
        textDecoration: 'underline',
    },
    display: 'inline',
});
